import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { MostUsedFoodItems } from "./MostUsedFoodItems";
import { EmptyFood } from "../empty-states/EmptyFood";
import SvgIcon from "../../../../../parts/SvgIcon";

const LOCATION_KEYS = {
  foods: "recentFoods.locationFoods",
  meals: "recentFoods.locationMeals",
  recipes: "recentFoods.locationRecipes",
};

export const RecentFoods = ({
  mostUsedToUse,
  location,
  setFoodActionState,
  onItemSelect,
}) => {
  const { t } = useTranslation("athlete-portal");
  const getTitle = () => {
    if (location === "all") return t("recentFoods.mostUsedFoods");
    const locationLabel = LOCATION_KEYS[location]
      ? t(LOCATION_KEYS[location])
      : location;
    return t("recentFoods.recentLabel", { location: locationLabel });
  };

  const icon =
    location === "meals"
      ? "/img/new-icons/meal.svg"
      : "/img/new-icons/food.svg";

  return (
    <div className="display-food">
      {mostUsedToUse.length > 0 ? (
        <>
          <div className="title">
            <span className="font-bold">{getTitle()}</span>
            {(location === "foods" || location === "meals") && (
              <div className="identifier">
                <SvgIcon src={icon} noFilterOnLight={false} />
                <span className="opacity-70">
                  {LOCATION_KEYS[location]
                    ? t(LOCATION_KEYS[location])
                    : location.slice(0, -1)}
                </span>
              </div>
            )}
          </div>
          <MostUsedFoodItems
            data={mostUsedToUse}
            setFoodActionState={setFoodActionState}
            location={location}
            onItemSelect={onItemSelect}
          />
        </>
      ) : (
        <EmptyFood label={location} variant="recent" />
      )}
    </div>
  );
};

RecentFoods.propTypes = {
  mostUsedToUse: PropTypes.array,
  location: PropTypes.string,
  onItemSelect: PropTypes.func,
  setFoodActionState: PropTypes.func,
};
